import { Switch } from "antd";
import styled from "styled-components";
import propTypes from "prop-types";
import { cn } from "utils/cn";

const StyledSwitch = styled(Switch)`
  &.ant-switch {
    min-width: ${props => props.size === 'small' ? '42px' : '64px'};
    height: ${props => props.size === 'small' ? '24px' : '28px'};
    line-height: ${props => props.size === 'small' ? '24px' : '28px'};
    border-radius: 50px;
  }

  &.ant-switch .ant-switch-handle {
    width: ${props => props.size === 'small' ? '20px' : '24px'};
    height: ${props => props.size === 'small' ? '20px' : '24px'};
    top: 2px;
    left: ${props => props.size === 'small' ? '2px' : '3px'};
  }

  &.ant-switch.ant-switch-checked .ant-switch-handle {
    inset-inline-start: ${props => props.size === 'small' ? 'calc(100% - 22px)' : 'calc(100% - 27px)'};
  }

  .ant-switch-handle::before {
    border-radius: 9999px;
  }

  .ant-switch-inner {
    margin: ${props => props.size === 'small' ? '0 5px 0 18px' : '0 5px 0 25px'};
  }

  &.ant-switch-checked .ant-switch-inner {
    margin: ${props => props.size === 'small' ? '0 18px 0 5px' : '0 25px 0 5px'};
  }

`;

/**
 * @param {Object} props
 * @param {boolean} [props.defaultChecked] - Initial checked state
 * @param {function(checked: boolean, event: Event): void} [props.onChange] - Callback when switch state changes
 * @param {React.ReactNode} [props.checkedChildren] - Content to show when checked
 * @param {React.ReactNode} [props.unCheckedChildren] - Content to show when unchecked
 * @param {string} [props.className] - Additional CSS class name
 * @param {"small" | "medium"} [props.size="medium"] - Size of the switch
 * @param {Object} [props.rest] - Other props passed to the underlying Switch component
 * @param {boolean} [props.disabled] - Whether the switch is disabled
 */
export const AntSwitch = ({
  defaultChecked,
  onChange,
  checkedChildren,
  unCheckedChildren,
  className,
  size = "medium",
  ...props
}) => {

  return (
    <StyledSwitch className={cn('bg-suzu-gray-1 aria-checked:bg-black', className)} checkedChildren={checkedChildren} unCheckedChildren={unCheckedChildren} defaultChecked={defaultChecked} onChange={onChange} size={size} {...props} />
  )
};

// PropTypes
AntSwitch.propTypes = {
  size: propTypes.oneOf(["small", "medium"]),
  defaultChecked: propTypes.bool,
  onChange: propTypes.func,
  checkedChildren: propTypes.node,
  unCheckedChildren: propTypes.node,
  className: propTypes.string,
  disabled: propTypes.bool,
};